module.exports = __webpack_public_path__ + "assets/docked_charging_adapter.ffcfb239.svg";